export default "__VITE_ASSET__CXFGqzAU__"